<template>
  <PSComponentListTable />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
